/* eslint-disable no-param-reassign */
import Phaser from 'phaser';
import EmptyBlock from './EmptyBlock';
import gameData from '../gameData';
import { Images as ABCyaImages, Tweens as ABCyaTweens } from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import BlobFill from './BlobFill';
import BlobCreate from './BlobCreate';
import BlobPush from './BlobPush';
import BlobRotate from './BlobRotate';


export default class GameGrid extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);

    const GRID_SIZE = 10;
    this.BLOCK_OFFSET = 70;
    this.blocksCreated = 0;

    this.numberBlocksToWin = [
      16,
      14,
      20,
      15,
      15,
      16,
      8,
      16,
      18,
      24,
      15,
      17,
      12,
      24,
      17,
      14,
      22,
      23,
      13,
      19,
      17,
      17,
      17,
      24,
      20,
      16,
      30,
      29,
      17,
      21,
      27,
      26,
      20,
      31,
      25,
      26,
      28,
      27,
      25,
      17,
      24,
      42,
      36,
      28,
      21

    ];

    this.grid = new Array(GRID_SIZE);

    for (let i = 0; i < GRID_SIZE; i++) {

      const subGrid = new Array(GRID_SIZE);

      for (let a = 0; a < GRID_SIZE; a++) {

        const emptyBlock = new EmptyBlock(this.scene, a, i, undefined);
        subGrid[a] = emptyBlock;
        this.add(emptyBlock);
        emptyBlock.x = a * this.BLOCK_OFFSET;
        emptyBlock.y = i * this.BLOCK_OFFSET;
      }

      this.grid[i] = subGrid;
    }

    this.levelTilesAndSolution = LEVELS[gameData.CURRENT_LEVEL];
    this.levelTiles = this.levelTilesAndSolution[0];

    // this rows and cols of these tiles sometimes don't start off at 0
    // let's store the min and max values for rows and columns and
    // offset grid accordingly

    let minRow = 10;
    let maxRow = 0;
    let minCol = 10;
    let maxCol = 0;

    for (let i = 0; i < this.levelTiles.length; i += 5) {

      const row = this.levelTiles[i] + 1;
      const col = this.levelTiles[i + 1] + 1;

      if (col < minCol) {
        minCol = col;
      }

      if (row < minRow) {
        minRow = row;
      }

      if (col > maxCol) {
        maxCol = col;
      }

      if (row > maxRow) {
        maxRow = row;
      }
    }

    for (let i = 0; i < this.levelTiles.length; i += 5) {

      const row = this.levelTiles[i] + 2 - minRow;
      const col = this.levelTiles[i + 1] + 2 - minCol;
      const tileType = this.levelTiles[i + 2];
      const direction = this.levelTiles[i + 3];
      const actionDirection = this.levelTiles[i + 4];

      let blobObject = null;

      switch (tileType) {

        case 0:
          blobObject = ABCyaImages.addImage(0, 0, UIAssetKeys._Block, this).setOrigin(0.5);

          blobObject.movable = false;
          blobObject.name = 'StaticBlock';
          blobObject.row = row;
          blobObject.column = col;
          blobObject.direction = direction;
          blobObject.setScale(0.8);
          break;

        case 1:
          blobObject = new BlobFill(this.scene, row, col, direction);
          blobObject.movable = true;
          this.blocksCreated++;
          break;

        case 2:
          blobObject = new BlobCreate(this.scene, row, col, direction);
          blobObject.movable = true;
          this.blocksCreated++;
          break;

        case 3:
          blobObject = new BlobPush(this.scene, row, col, direction);
          blobObject.movable = true;
          this.blocksCreated++;
          break;

        case 4:
          blobObject = new BlobRotate(this.scene, row, col, direction);
          blobObject.movable = true;
          this.blocksCreated++;
          break;
      }

      let angle = 0;

      switch (direction) {
        case -1:
        case 0:
        case 6:
          angle = 0;
          break;

        case 1:
          angle = 90;
          break;

        case 2:
          angle = 180;
          break;

        case 3:
          angle = 270;
          break;
      }

      this.add(blobObject);
      blobObject.x = row * this.BLOCK_OFFSET;
      blobObject.y = col * this.BLOCK_OFFSET;

      blobObject.setAngle(angle);

      this.grid[col - 1][row - 1] = blobObject;
    }
  };

  getGridSize() {
    const size = { width: 0, height: 0 };
    const output = new Phaser.Geom.Rectangle().setTo(this.x, this.y, 0, 0);

    if (this.list.length > 0) {
      const children = this.list;
      const tempRect = new Phaser.Geom.Rectangle();
      let hasSetFirst = false;

      output.setEmpty();

      for (let i = 0; i < children.length; i++) {
        const entry = children[i];

        if (entry instanceof EmptyBlock) continue;

        if (entry.getBounds) {
          entry.getBounds(tempRect);

          if (!hasSetFirst) {
            output.setTo(tempRect.x, tempRect.y, tempRect.width, tempRect.height);
            hasSetFirst = true;
          }
          else {
            Phaser.Geom.Rectangle.Union(tempRect, output, output);
          }
        }
      }
    }

    size.width = output.width;
    size.height = output.height;

    return size;
  }

  checkRotateBlock(startBlock) {
    const col = startBlock.column;
    const row = startBlock.row;

    const blockAbove = this.grid[col - 1 - 1][row - 1];
    const blockBelow = this.grid[col + 1 - 1][row - 1];
    const blockRight = this.grid[col - 1][row + 1 - 1];
    const blockLeft = this.grid[col - 1][row - 1 - 1];
    const blocks = [blockAbove, blockBelow, blockRight, blockLeft];

    let activeAnims = 0;
    blocks.forEach((block) => {
      // check the adjacent blocks for creator or pusher blocks
      if (block && (block.name === 'BlobCreate' || block.name === 'BlobPush')) {
        // +1 if they are playing an animation.
        if (block.playingAnim) activeAnims++;
      }
    });

    // if an animation was playing return false to prevent input.
    if (activeAnims > 0) return false;
    else return true;
  }

  rotateBlock (startBlock) {
    const col = startBlock.column;
    const row = startBlock.row;

    const blockAbove = this.grid[col - 1 - 1][row - 1];
    const blockBelow = this.grid[col + 1 - 1][row - 1];
    const blockRight = this.grid[col - 1][row + 1 - 1];
    const blockLeft = this.grid[col - 1][row - 1 - 1];

    this.rotate(blockAbove);
    this.rotate(blockBelow);
    this.rotate(blockRight);
    this.rotate(blockLeft);
  }

  rotate (block) {
    if (block && (block.name === 'BlobCreate' || block.name === 'BlobPush')) {
      block.rotate();
    }
  }

  //   //this will move a block and move others if there is empty space
  pushBlock (startBlock, direction, counter) {
    const col = startBlock.column;
    const row = startBlock.row;

    let newCol = col;
    let newRow = row;

    switch (direction) {

      case 0: // up
        newCol = col - 1;
        break;

      case 1: // right
        newRow = row + 1;
        break;

      case 2: // down
        newCol = col + 1;
        break;

      case 3: // left
        newRow = row - 1;
        break;
    }

    if (newCol > 10 || newCol < 1 || newRow > 10 || newRow < 1) {
      // end of line -- shouldn't happen because levels are
      // always surrounded by static blocks
      console.error('problem in level file -- static blocks should surround movable blocks!');
      return false;
    }

    const nextBlock = this.grid[newCol - 1][newRow - 1];

    if (nextBlock instanceof EmptyBlock) {
      // if we have an empty block, we'll swap it with object in previous grid space

      if (counter !== 0) {
        const emptyBlock = new EmptyBlock(this.scene);

        this.grid[col - 1][row - 1] = emptyBlock;
        emptyBlock.column = col;
        emptyBlock.row = row;

        this.grid[newCol - 1][newRow - 1] = startBlock;
        this.push(startBlock, newRow * this.BLOCK_OFFSET, newCol * this.BLOCK_OFFSET);
        startBlock.column = newCol;
        startBlock.row = newRow;

        startBlock.debug();
      }
      else if (counter === 0) {
        const emptyBlock = new EmptyBlock(this.scene);

        this.grid[col - 1][row - 1] = emptyBlock;
        emptyBlock.column = col;
        emptyBlock.row = row;
      }

      return true;
    }
    else if (nextBlock.movable === false) {
      return false;
    }
    else {
      // found block that is movable, iterate to see if there is 'null' space between
      // it and non-movable blocks

      const value = this.pushBlock(nextBlock, direction, counter + 1);

      if (value && counter !== 0) {
        this.grid[col - 1][row - 1] = nextBlock;
        this.push(nextBlock, row * this.BLOCK_OFFSET, col * this.BLOCK_OFFSET);
        nextBlock.column = col;
        nextBlock.row = row;

        this.grid[newCol - 1][newRow - 1] = startBlock;

        this.push(startBlock, newRow * this.BLOCK_OFFSET, newCol * this.BLOCK_OFFSET);
        startBlock.column = newCol;
        startBlock.row = newRow;

      }
      else if (value && counter === 0) {
        const emptyBlock = new EmptyBlock(this.scene);

        this.grid[col - 1][row - 1] = emptyBlock;
        emptyBlock.column = col;
        emptyBlock.row = row;

      }

      return value;
    }
  }

  //   //this will move a block and move others if there is empty space
  canPushBlock (startBlock, direction, counter) {
    const col = startBlock.column;
    const row = startBlock.row;

    let newCol = col;
    let newRow = row;

    switch (direction) {
      case 0: // up
        newCol = col - 1;
        break;

      case 1: // right
        newRow = row + 1;
        break;

      case 2: // down
        newCol = col + 1;
        break;

      case 3: // left
        newRow = row - 1;
        break;
    }

    if (newCol > 10 || newCol < 1 || newRow > 10 || newRow < 1) {
      // end of line -- shouldn't happen because levels are
      // always surrounded by static blocks
      console.error('problem in level file -- static blocks should surround movable blocks!');
      return [false, 0];
    }

    const nextBlock = this.grid[newCol - 1][newRow - 1];

    if (nextBlock instanceof EmptyBlock) {
      // if we have an empty block, we'll swap it with object in previous grid space
      return [true, counter];
    }
    else if (nextBlock.movable === false) {
      return [false, 0];
    }
    else {
      // found block that is movable, iterate to see if there is 'null' space between
      // it and non-movable blocks

      return this.canPushBlock(nextBlock, direction, counter + 1);
    }
  }

  moveBlocks(startBlock, direction, numberBlocks, isCreateBlob) {
    const col = startBlock.column;
    const row = startBlock.row;

    let newCol = col;
    let newRow = row;


    // depending on type of move, we'll fill first grid space with emptyBlock
    // or with fillBlock depending on blob clicked, PushBlob, or CreateBlob respectively
    for (let i = 0; i < numberBlocks; i++) {
      switch (direction) {
        case 0: // up
          newCol = newCol - 1;
          break;

        case 1: // right
          newRow = newRow + 1;
          break;

        case 2: // down
          newCol = newCol + 1;
          break;

        case 3: // left
          newRow = newRow - 1;
          break;
      }

      if (newCol > 10 || newCol < 1 || newRow > 10 || newRow < 1) {
        return null;
      }

      const tempBlock = this.grid[newCol - 1][newRow - 1];

      if (i > 0) {
        this.grid[newCol - 1][newRow - 1] = startBlock;
        startBlock.column = newCol;
        startBlock.row = newRow;
        this.push(startBlock, newRow * this.BLOCK_OFFSET, newCol * this.BLOCK_OFFSET);
      }
      else {
        if (isCreateBlob) {
          console.log('clicked on creator');
          const blobObject = new BlobFill(this.scene, newRow, newCol, direction);
          this.blocksCreated++;
          blobObject.movable = true;
          blobObject.x = newRow * this.BLOCK_OFFSET;
          blobObject.y = newCol * this.BLOCK_OFFSET;
          this.grid[newCol - 1][newRow - 1] = blobObject;
          blobObject.alpha = 0;
          this.add(blobObject);

          this.scene.time.delayedCall(1000, () => {blobObject.setAlpha(1);});

          this.checkWin();

        }
        else {
          const emptyBlock = new EmptyBlock(this.scene);
          this.grid[newCol - 1][newRow - 1] = emptyBlock;
          emptyBlock.column = newCol;
          emptyBlock.row = newRow;
        }
      }

      startBlock = tempBlock;
    }
  }

  moveBlocksBackwards(startBlock, direction, numberBlocks, isCreateBlob) {
    const col = startBlock.column;
    const row = startBlock.row;

    let newCol = col;
    let newRow = row;

    if (isCreateBlob) {
      const blobObject = new BlobFill(this.scene, newRow, newCol, direction);
      this.blocksCreated++;
      blobObject.movable = true;
      blobObject.x = newRow * this.BLOCK_OFFSET;
      blobObject.y = newCol * this.BLOCK_OFFSET;

      this.grid[newCol - 1][newRow - 1] = blobObject;
      blobObject.alpha = 0;
      this.add(blobObject);

      this.scene.time.delayedCall(1000, () => {blobObject.setAlpha(1);});

      this.checkWin();
    }
    else {
      const emptyBlock = new EmptyBlock(this.scene);
      this.grid[newCol - 1][newRow - 1] = emptyBlock;
      emptyBlock.column = newCol;
      emptyBlock.row = newRow;
    }

    // depending on type of move, we'll fill first grid space with emptyBlock
    // or with fillBlock depending on blob clicked, PushBlob, or CreateBlob respectively

    for (let i = 0; i < numberBlocks; i++) {
      switch (direction) {
        case 0: // up
          newCol = newCol + 1;
          break;

        case 1: // right
          newRow = newRow - 1;
          break;

        case 2: // down
          newCol = newCol - 1;
          break;

        case 3: // left
          newRow = newRow + 1;
          break;
      }

      if (newCol > 10 || newCol < 1 || newRow > 10 || newRow < 1) {
        console.error('problem in level file -- static blocks should surround movable blocks!');
        return null;
      }

      const tempBlock = this.grid[newCol - 1][newRow - 1];

      this.grid[newCol - 1][newRow - 1] = startBlock;
      startBlock.column = newCol;
      startBlock.row = newRow;
      this.push(startBlock, newRow * this.BLOCK_OFFSET, newCol * this.BLOCK_OFFSET);
      startBlock = tempBlock;
    }
  }

  checkWin () {
    const totalToWin = this.numberBlocksToWin[gameData.CURRENT_LEVEL - 1];

    if (this.blocksCreated >= totalToWin) {
      this.scene.time.delayedCall(1000, () => {
        this.emit('WIN');
      });
    }
  }

  push (sprite, x, y) {
    ABCyaTweens.addTween(sprite, 500, { x, y }, Phaser.Math.Easing.Linear);
  }

  /*

     this cryptic array format inherited from original game designer, there are 45 levels. first array, is tile layout, second is tile 'solution'
     [tiles] => [u1, v1, tileType1, direction1, actionDirection1, u2, v2, tileType2,..]

     tileType1:
     0 - Static,
     1 - Basic,
     2 - Producer,
     3 - Pusher,
     4 - Turner.

     direction1,
     actionDirection1:
     -1 - None,
     0 - Up,
     1 - Right,
     2 - Down,
     3 - Left,
     6 - All.

     */
}

const LEVELS = {

  1: [[4, 5, 2, 1, 0, 8, 6, 2, 0, 0, 3, 4, 0, 0, -1, 3, 5, 0, 0, -1, 7, 7, 0, 0, -1, 8, 7, 0, 0, -1, 9, 7, 0, 0, -1, 7, 3, 0, 0, -1, 3, 3, 0, 0, -1, 4, 3, 0, 0, -1, 5, 3, 0, 0, -1, 6, 3, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 9, 6, 2, 0, 0, 4, 6, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 3, 6, 0, 0, -1, 10, 7, 0, 0, -1, 4, 4, 2, 1, 0], [4, 5, 4, 5, 4, 5, 4, 5, 4, 5, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 8, 6, 9, 6]],
  2: [[3, 3, 0, 0, -1, 4, 3, 0, 0, -1, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 8, 3, 0, 0, -1, 8, 4, 0, 0, -1, 8, 5, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 4, 4, 2, 2, 0, 5, 5, 2, 0, 0, 6, 4, 2, 2, 0, 7, 4, 2, 0, 0], [4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 6, 4, 6, 4, 6, 4, 7, 4, 7, 4]],
  3: [[6, 6, 2, 0, 0, 7, 6, 2, 0, 0, 7, 4, 2, 1, 0, 6, 4, 2, 3, 0, 3, 3, 0, 0, -1, 3, 4, 0, 0, -1, 4, 4, 0, 0, -1, 5, 4, 0, 0, -1, 5, 5, 0, 0, -1, 5, 6, 0, 0, -1, 5, 7, 0, 0, -1, 6, 7, 0, 0, -1, 7, 7, 0, 0, -1, 8, 7, 0, 0, -1, 8, 6, 0, 0, -1, 8, 5, 0, 0, -1, 8, 4, 0, 0, -1, 9, 4, 0, 0, -1, 10, 4, 0, 0, -1, 10, 3, 0, 0, -1, 10, 2, 0, 0, -1, 10, 1, 0, 0, -1, 9, 1, 0, 0, -1, 8, 1, 0, 0, -1, 5, 1, 0, 0, -1, 4, 1, 0, 0, -1, 3, 1, 0, 0, -1, 3, 2, 0, 0, -1, 5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 7, 0, 0, 0, -1, 8, 0, 0, 0, -1], [6, 6, 6, 6, 7, 6, 7, 6, 6, 3, 6, 3, 7, 3, 7, 3, 6, 6, 7, 6, 6, 2, 6, 2, 7, 2, 7, 2, 6, 6, 7, 6]],
  4: [[3, 3, 0, 0, -1, /* 4, 4, 1, 0, -1, */ 6, 2, 0, 0, -1, 8, 3, 0, 0, -1, 8, 4, 0, 0, -1, 8, 5, 0, 0, -1, 8, 6, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 3, 6, 0, 0, -1, 3, 4, 0, 0, -1, 8, 7, 0, 0, -1, 2, 6, 0, 0, -1, 2, 5, 0, 0, -1, 2, 4, 0, 0, -1, 3, 2, 0, 0, -1, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 3, 0, 0, -1, 7, 3, 0, 0, -1, 3, 5, 2, 1, 0, 4, 6, 3, 0, 0, 5, 6, 3, 0, 0, 6, 6, 3, 0, 0, 7, 6, 3, 0, 0], [3, 5, 3, 5, 3, 5, 3, 5, 4, 6, 5, 6, 6, 6, 7, 6, 3, 5, 3, 5, 3, 5, 3, 5, 4, 6, 5, 6, 3, 5, 3, 5]],
  5: [[9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 9, 3, 0, 0, -1, 8, 3, 0, 0, -1, 8, 4, 2, 3, 0, 8, 5, 2, 3, 0, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 4, 6, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 8, 2, 0, 0, -1, 7, 2, 0, 0, -1, 7, 1, 0, 0, -1, 6, 1, 0, 0, -1, 5, 1, 0, 0, -1, 4, 1, 0, 0, -1, 4, 2, 0, 0, -1, 4, 3, 0, 0, -1, 3, 3, 0, 0, -1, 7, 5, 3, 0, 0], [8, 4, 7, 5, 8, 4, 8, 5, 8, 4, 6, 5, 8, 4, 6, 5, 8, 4, 8, 5, 8, 4, 5, 5, 8, 4, 5, 5, 8, 4, 8, 4, 8, 5]],
  6: [[4, 2, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 4, 3, 0, 0, -1, 4, 4, 0, 0, -1, 4, 5, 0, 0, -1, 4, 6, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 6, 3, 2, 1, 0, 7, 3, 2, 2, 0, 7, 4, 2, 3, 0, 6, 4, 2, 0, 0], [7, 3, 7, 3, 6, 4, 6, 4, 6, 2, 6, 2, 7, 5, 7, 5, 8, 2, 8, 2, 5, 5, 5, 5]],
  7: [[6, 5, 4, 0, -1, 6, 4, 2, 0, 0, 5, 5, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 7, 5, 0, 0, -1, 8, 5, 0, 0, -1, 9, 5, 0, 0, -1, 9, 4, 0, 0, -1, 9, 3, 0, 0, -1, 8, 3, 0, 0, -1, 7, 3, 0, 0, -1, 7, 2, 0, 0, -1, 7, 1, 0, 0, -1, 6, 1, 0, 0, -1, 5, 1, 0, 0, -1, 5, 2, 0, 0, -1, 5, 3, 0, 0, -1, 4, 3, 0, 0, -1, 3, 3, 0, 0, -1, 3, 4, 0, 0, -1, 3, 5, 0, 0, -1, 4, 5, 0, 0, -1], [6, 4, 6, 4, 6, 5, 6, 4, 6, 4, 6, 4, 5, 4]],
  8: [[3, 0, 0, 0, -1, 4, 0, 0, 0, -1, 5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 4, 3, 2, 1, 0, 6, 5, 0, 0, -1, 5, 5, 0, 0, -1, 4, 5, 0, 0, -1, 3, 5, 0, 0, -1, 9, 2, 0, 0, -1, 5, 4, 4, 0, 0, 3, 1, 0, 0, -1, 3, 2, 0, 0, -1, 3, 3, 0, 0, -1, 3, 4, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 8, 5, 0, 0, -1, 7, 5, 0, 0, -1, 6, 2, 2, 0, 0, 7, 1, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 7, 0, 0, 0, -1], [6, 2, 6, 2, 6, 3, 5, 4, 6, 4, 6, 4, 6, 4, 4, 3, 4, 3, 4, 3, 4, 4, 4, 4, 4, 4, 4, 3, 4, 3, 5, 4, 5, 4]],
  9: [[3, 2, 0, 0, -1, 8, 2, 0, 0, -1, 3, 6, 0, 0, -1, 2, 5, 0, 0, -1, 2, 4, 0, 0, -1, 2, 3, 0, 0, -1, 7, 2, 0, 0, -1, 5, 2, 0, 0, -1, 2, 6, 0, 0, -1, 3, 7, 0, 0, -1, 4, 7, 0, 0, -1, 5, 7, 0, 0, -1, 7, 7, 0, 0, -1, 8, 7, 0, 0, -1, 3, 4, 4, 0, 0, 4, 3, 2, 0, 0, 3, 3, 0, 0, -1, 4, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 6, 0, 0, -1, 5, 3, 0, 0, -1, 6, 3, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 9, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 9, 7, 0, 0, -1, 9, 5, 4, 0, 0, 8, 6, 2, 2, 0, 7, 6, 0, 0, -1, 7, 3, 0, 0, -1], [4, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 8, 6, 9, 5, 8, 5, 8, 5, 8, 5, 8, 5, 8, 5, 3, 4, 4, 4, 9, 5, 8, 5]],
  10: [[10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 7, 8, 0, 0, -1, 6, 8, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 11, 4, 0, 0, -1, 11, 5, 0, 0, -1, 11, 6, 0, 0, -1, 11, 7, 0, 0, -1, 10, 1, 0, 0, -1, 11, 2, 0, 0, -1, 11, 3, 0, 0, -1, 7, 4, 4, 0, 0, 9, 6, 4, 0, 0, 8, 3, 2, 0, 0, 10, 3, 4, 0, 0, 6, 2, 0, 0, -1, 6, 5, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 5, 6, 0, 0, -1, 5, 5, 0, 0, -1, 5, 4, 0, 0, -1, 5, 3, 0, 0, -1, 5, 2, 0, 0, -1, 10, 7, 0, 0, -1, 10, 5, 0, 0, -1, 10, 2, 0, 0, -1], [8, 3, 8, 3, 8, 4, 8, 5, 9, 6, 9, 6, 8, 6, 9, 6, 8, 6, 8, 6, 8, 6, 10, 6, 10, 6, 10, 6, 9, 6, 9, 6, 9, 5, 9, 4, 10, 3, 10, 3, 9, 3, 10, 3, 9, 3, 8, 3, 7, 4, 7, 4, 7, 4, 7, 3, 7, 3, 7, 5, 7, 4, 7, 5, 7, 5, 7, 4, 7, 5, 7, 4]],

  11: [[8, 2, 0, 0, -1, 7, 2, 0, 0, -1, 5, 2, 0, 0, -1, 4, 2, 0, 0, -1, 6, 2, 0, 0, -1, 4, 8, 0, 0, -1, 5, 8, 0, 0, -1, 6, 8, 0, 0, -1, 7, 8, 0, 0, -1, 8, 8, 0, 0, -1, 4, 6, 0, 0, -1, 4, 7, 0, 0, -1, 4, 5, 0, 0, -1, 4, 4, 0, 0, -1, 4, 3, 0, 0, -1, 8, 3, 0, 0, -1, 8, 4, 0, 0, -1, 8, 5, 0, 0, -1, 8, 6, 0, 0, -1, 8, 7, 0, 0, -1, 6, 4, 4, 0, 0, 5, 4, 2, 0, 0, 7, 3, 3, 2, 0], [5, 4, 6, 4, 6, 4, 5, 4, 5, 4, 5, 4, 5, 4, 6, 4, 5, 4, 7, 4, 6, 4, 7, 4, 7, 4, 6, 4, 6, 4, 6, 4, 7, 4, 7, 3, 6, 4, 7, 5, 7, 4, 7, 5]],
  12: [[3, 2, 0, 0, -1, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 8, 3, 0, 0, -1, 3, 3, 0, 0, -1, 8, 4, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 8, 7, 0, 0, -1, 6, 7, 0, 0, -1, 7, 7, 0, 0, -1, 5, 7, 0, 0, -1, 2, 4, 0, 0, -1, 2, 6, 0, 0, -1, 2, 5, 0, 0, -1, 2, 3, 0, 0, -1, 5, 3, 2, 2, 0, 3, 5, 2, 1, 0, 6, 5, 2, 0, 0, 6, 4, 4, 3, 0, 8, 6, 0, 0, -1, 5, 6, 0, 0, -1, 4, 6, 0, 0, -1, 3, 6, 0, 0, -1], [6, 4, 6, 4, 6, 5, 6, 5, 6, 3, 5, 3, 6, 4, 6, 4, 6, 4, 3, 5, 6, 3, 6, 3, 6, 3, 6, 3, 6, 4, 5, 3, 3, 5, 3, 5, 3, 5, 7, 3, 7, 3, 7, 3, 7, 4]],
  13: [[7, 6, 0, 0, -1, 8, 6, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 7, 2, 3, 2, 0, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 4, 3, 0, 0, -1, 5, 3, 3, 1, 0, 9, 3, 0, 0, -1, 4, 4, 0, 0, -1, 9, 4, 0, 0, -1, 8, 4, 3, 3, 0, 4, 5, 0, 0, -1, 5, 5, 0, 0, -1, 6, 5, 2, 0, 0, 8, 5, 0, 0, -1, 9, 5, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1], [6, 5, 6, 5, 6, 5, 5, 3, 6, 5, 5, 3, 6, 5, 7, 2, 5, 3, 6, 5, 8, 4, 7, 2, 5, 3, 6, 5, 7, 2, 5, 3, 6, 5]],
  14: [[3, 2, 0, 0, -1, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 7, 3, 0, 0, -1, 3, 3, 0, 0, -1, 2, 3, 0, 0, -1, 1, 3, 0, 0, -1, 1, 4, 0, 0, -1, 1, 5, 0, 0, -1, 1, 6, 0, 0, -1, 1, 7, 0, 0, -1, 2, 7, 0, 0, -1, 3, 7, 0, 0, -1, 4, 7, 0, 0, -1, 5, 7, 0, 0, -1, 6, 7, 0, 0, -1, 7, 7, 0, 0, -1, 8, 7, 0, 0, -1, 9, 7, 0, 0, -1, 8, 3, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 4, 5, 2, 1, 0, 5, 5, 2, 0, 0, 8, 6, 2, 3, 0], [5, 5, 5, 5, 5, 5, 4, 5, 4, 5, 4, 5, 8, 6, 8, 6, 8, 6, 4, 6, 4, 4, 4, 4, 4, 4, 4, 6, 4, 3, 8, 6, 3, 6, 3, 6, 8, 6, 2, 6, 2, 6]],
  15: [[4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 4, 3, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 7, 3, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 9, 6, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 4, 6, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 3, 2, 0, 0, -1, 5, 3, 4, 0, 0, 6, 3, 0, 0, -1, 6, 4, 2, 1, 0, 7, 5, 3, 0, 0, 4, 5, 3, 1, 0], [6, 4, 6, 4, 6, 4, 6, 4, 5, 3, 5, 4, 4, 5, 5, 4, 4, 5, 8, 5, 5, 3, 5, 3, 5, 3, 5, 4, 8, 5, 5, 4, 5, 3, 5, 4, 4, 5, 9, 5, 5, 3, 5, 3, 5, 3, 5, 4, 9, 5, 5, 4, 5, 3, 5, 4, 5, 3, 5, 4]],
  16: [[6, 4, 4, 2, -1, 7, 4, 2, 0, 0, 5, 4, 2, 2, 0, 3, 5, 3, 1, 0, 2, 3, 0, 0, -1, 2, 4, 0, 0, -1, 2, 5, 0, 0, -1, 2, 6, 0, 0, -1, 3, 6, 0, 0, -1, 4, 6, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 8, 6, 0, 0, -1, 9, 6, 0, 0, -1, 10, 6, 0, 0, -1, 10, 5, 0, 0, -1, 10, 4, 0, 0, -1, 10, 3, 0, 0, -1, 3, 3, 0, 0, -1, 4, 3, 0, 0, -1, 5, 3, 0, 0, -1, 6, 3, 0, 0, -1, 7, 3, 0, 0, -1, 8, 3, 0, 0, -1, 9, 3, 0, 0, -1], [6, 4, 7, 4, 7, 4, 6, 4, 6, 4, 7, 4, 5, 4, 5, 4, 4, 4, 5, 4, 5, 4, 5, 4, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4]],
  17: [[5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 10, 7, 0, 0, -1, 7, 6, 2, 0, 0, 8, 3, 2, 2, 0, 8, 5, 4, 0, 0, 9, 7, 3, 0, 0, 10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 5, 3, 0, 0, -1, 5, 4, 0, 0, -1, 4, 4, 0, 0, -1, 10, 4, 0, 0, -1, 7, 8, 0, 0, -1], [8, 3, 8, 3, 7, 6, 7, 6, 7, 6, 8, 6, 8, 6, 8, 6, 7, 6, 7, 6, 7, 6, 7, 6, 9, 6, 9, 6, 9, 6, 8, 6, 9, 6, 9, 7, 8, 6, 9, 5, 9, 5, 9, 5, 9, 6, 9, 4, 9, 5, 9, 5, 9, 5, 9, 4, 9, 4, 9, 4, 9, 5, 9, 3, 9, 4, 8, 3]],
  18: [[1, 5, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 8, 5, 0, 0, -1, 8, 4, 0, 0, -1, 8, 3, 0, 0, -1, 8, 2, 0, 0, -1, 8, 1, 0, 0, -1, 7, 0, 0, 0, -1, 6, 0, 0, 0, -1, 5, 0, 0, 0, -1, 1, 1, 0, 0, -1, 2, 3, 2, 3, 0, 3, 4, 2, 0, 0, 5, 2, 4, 0, 0, 0, 1, 0, 0, -1, 0, 2, 0, 0, -1, 0, 3, 0, 0, -1, 0, 4, 0, 0, -1, 0, 5, 0, 0, -1, 6, 1, 3, 2, 0, 2, 1, 0, 0, -1, 3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 7, 1, 0, 0, -1, 2, 5, 0, 0, -1, 3, 5, 0, 0, -1, 4, 5, 0, 0, -1, 7, 5, 0, 0, -1, 5, 5, 0, 0, -1], [2, 3, 2, 3, 3, 4, 3, 2, 3, 2, 3, 2, 4, 2, 6, 1, 5, 2, 6, 3, 6, 3, 6, 2, 6, 1, 6, 4, 6, 4, 6, 3, 6, 3, 6, 4, 6, 3, 6, 4, 6, 3, 6, 1, 6, 4, 6, 5, 6, 5, 6, 4, 6, 4, 6, 4, 6, 4, 6, 5, 6, 4]],
  19: [[4, 1, 0, 0, -1, 3, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 2, 0, 0, -1, 8, 3, 0, 0, -1, 8, 4, 0, 0, -1, 8, 5, 0, 0, -1, 7, 5, 0, 0, -1, 6, 5, 0, 0, -1, 5, 5, 0, 0, -1, 4, 5, 0, 0, -1, 3, 5, 0, 0, -1, 2, 5, 0, 0, -1, 2, 4, 0, 0, -1, 2, 3, 0, 0, -1, 2, 2, 0, 0, -1, 4, 2, 2, 0, 0, 5, 3, 4, 0, 0, 6, 2, 3, 3, 0, 7, 2, 0, 0, -1, 3, 2, 0, 0, -1], [4, 2, 5, 3, 5, 3, 5, 3, 4, 3, 4, 3, 6, 3, 5, 3, 6, 2, 5, 3, 6, 4, 6, 4, 6, 4, 5, 4, 5, 4, 5, 4, 6, 3, 7, 4, 6, 4, 6, 4]],
  20: [[1, 3, 0, 0, -1, 1, 4, 0, 0, -1, 1, 5, 0, 0, -1, 2, 2, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 1, 2, 0, 0, -1, 2, 6, 0, 0, -1, 2, 5, 0, 0, -1, 6, 4, 4, 0, 0, 4, 5, 2, 3, 0, 5, 5, 3, 0, 0, 7, 6, 0, 0, -1, 8, 4, 0, 0, -1, 2, 3, 2, 0, 0, 7, 2, 2, 2, 0, 3, 6, 0, 0, -1, 4, 6, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 8, 6, 0, 0, -1, 8, 5, 0, 0, -1, 8, 3, 0, 0, -1, 8, 2, 0, 0, -1, 5, 2, 0, 0, -1, 4, 2, 0, 0, -1, 3, 2, 0, 0, -1], [4, 5, 4, 5, 6, 4, 6, 4, 5, 5, 7, 5, 6, 4, 7, 4, 6, 5, 7, 4, 6, 5, 7, 4, 6, 5, 7, 4, 2, 4, 2, 3, 2, 3, 2, 3, 6, 5, 6, 5, 6, 5, 7, 2, 7, 2]],

  21: [[3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 4, 7, 0, 0, -1, 6, 7, 0, 0, -1, 7, 7, 0, 0, -1, 5, 7, 0, 0, -1, 8, 7, 0, 0, -1, 9, 7, 0, 0, -1, 10, 7, 0, 0, -1, 10, 6, 0, 0, -1, 10, 5, 0, 0, -1, 10, 4, 0, 0, -1, 10, 3, 0, 0, -1, 6, 4, 2, 2, 0, 7, 5, 2, 1, 0, 5, 6, 2, 0, 0, 4, 6, 0, 0, -1, 4, 3, 0, 0, -1, 5, 3, 0, 0, -1, 6, 3, 0, 0, -1, 7, 3, 0, 0, -1, 8, 3, 0, 0, -1, 9, 3, 0, 0, -1], [5, 6, 7, 5, 7, 5, 7, 5, 6, 5, 5, 6, 6, 4, 5, 4, 7, 4, 5, 4, 8, 4, 5, 4, 9, 4, 5, 4]],
  22: [[3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 1, 5, 0, 0, -1, 1, 4, 0, 0, -1, 1, 3, 0, 0, -1, 1, 2, 0, 0, -1, 4, 4, 2, 2, 0, 6, 5, 3, 0, 0, 5, 3, 4, 0, 0, 3, 4, 3, 1, 0, 4, 6, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 8, 5, 0, 0, -1, 8, 4, 0, 0, -1, 8, 3, 0, 0, -1, 8, 2, 0, 0, -1, 3, 6, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 7, 5, 0, 0, -1, 2, 5, 0, 0, -1, 2, 2, 0, 0, -1, 3, 2, 0, 0, -1, 3, 5, 0, 0, -1], [4, 4, 4, 4, 5, 3, 4, 3, 4, 3, 5, 3, 4, 3, 3, 4, 4, 3, 3, 4, 5, 3, 5, 4, 5, 3, 5, 4, 5, 3, 5, 4, 5, 4, 5, 3, 5, 3, 5, 3, 5, 4, 5, 2, 5, 2, 5, 2, 5, 3, 5, 3]],
  23: [[8, 0, 0, 0, -1, 7, 0, 0, 0, -1, 6, 0, 0, 0, -1, 5, 0, 0, 0, -1, 9, 0, 0, 0, -1, 4, 3, 0, 0, -1, 4, 2, 0, 0, -1, 4, 1, 0, 0, -1, 4, 0, 0, 0, -1, 10, 0, 0, 0, -1, 5, 4, 0, 0, -1, 6, 4, 0, 0, -1, 7, 4, 0, 0, -1, 9, 4, 0, 0, -1, 10, 4, 0, 0, -1, 7, 2, 4, 1, 0, 6, 2, 2, 0, 0, 8, 2, 2, 0, 0, 8, 4, 0, 0, -1, 5, 3, 0, 0, -1, 11, 0, 0, 0, -1, 11, 1, 0, 0, -1, 11, 2, 0, 0, -1, 11, 3, 0, 0, -1, 11, 4, 0, 0, -1], [7, 2, 7, 2, 6, 2, 6, 2, 7, 2, 7, 2, 7, 2, 8, 2, 8, 2, 8, 2, 6, 2, 7, 2, 7, 2, 6, 1, 6, 1, 8, 1, 7, 1, 9, 1, 8, 1, 10, 1]],
  24: [[10, 4, 0, 0, -1, 11, 0, 0, 0, -1, 11, 1, 0, 0, -1, 11, 2, 0, 0, -1, 11, 3, 0, 0, -1, 11, 4, 0, 0, -1, 4, -1, 0, 0, -1, 3, -1, 0, 0, -1, 3, 0, 0, 0, -1, 3, 1, 0, 0, -1, 3, 2, 0, 0, -1, 3, 3, 0, 0, -1, 3, 4, 0, 0, -1, 4, 4, 0, 0, -1, 11, -1, 0, 0, -1, 10, -1, 0, 0, -1, 9, -1, 0, 0, -1, 7, -1, 0, 0, -1, 6, -1, 0, 0, -1, 5, -1, 0, 0, -1, 8, -1, 0, 0, -1, 7, 5, 0, 0, -1, 8, 5, 0, 0, -1, 9, 5, 0, 0, -1, 10, 5, 0, 0, -1, 9, 4, 2, 0, 0, 5, 3, 2, 1, 0, 8, 4, 3, 0, 0, 9, 1, 3, 3, 0, 5, 0, 3, 2, 0, 7, 4, 0, 0, -1, 6, 4, 0, 0, -1, 5, 4, 0, 0, -1, 4, 1, 0, 0, -1, 4, 2, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1], [5, 3, 5, 3, 5, 3, 8, 4, 5, 3, 8, 4, 5, 3, 9, 1, 8, 4, 5, 3, 9, 1, 8, 4, 5, 3, 9, 1, 5, 0, 8, 4, 5, 3, 9, 1, 8, 4, 5, 3, 8, 4, 5, 3, 9, 4, 9, 4, 9, 4, 9, 0, 8, 4, 9, 0, 5, 3, 8, 4, 9, 0, 5, 3, 8, 4, 9, 0, 5, 3, 5, 3, 5, 3, 9, 4]],
  25: [[1, 1, 0, 0, -1, 2, 1, 0, 0, -1, 3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 3, 6, 0, 0, -1, 4, 6, 0, 0, -1, 2, 6, 0, 0, -1, 1, 5, 0, 0, -1, 1, 4, 0, 0, -1, 1, 3, 0, 0, -1, 1, 2, 0, 0, -1, 5, 3, 2, 1, 0, 4, 4, 2, 2, 0, 3, 2, 3, 2, 0, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 8, 4, 0, 0, -1, 8, 5, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 8, 3, 3, 3, 0, 7, 5, 2, 0, 0, 2, 5, 0, 0, -1], [4, 4, 4, 4, 5, 3, 5, 3, 5, 3, 4, 3, 2, 3, 2, 3, 3, 2, 8, 3, 7, 5, 7, 5, 3, 4, 3, 4, 3, 2, 8, 3, 7, 5, 3, 5, 3, 5]],
  26: [[6, 5, 2, 0, 0, 5, 5, 4, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 6, 0, 0, -1, 9, 6, 0, 0, -1, 7, 2, 0, 0, -1, 4, 2, 0, 0, -1, 3, 3, 0, 0, -1, 3, 2, 0, 0, -1, 5, 2, 0, 0, -1, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 7, 0, 0, -1, 8, 7, 0, 0, -1, 7, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 5, 3, 0, 0, -1, 5, 6, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 8, 4, 4, 0, -1, 7, 3, 0, 0, -1, 6, 3, 0, 0, -1, 7, 6, 0, 0, -1, 6, 6, 0, 0, -1], [5, 5, 5, 5, 5, 5, 6, 5, 6, 5, 7, 5, 8, 4, 8, 4, 8, 5, 8, 4, 8, 5, 8, 5, 8, 3, 8, 3, 8, 3, 8, 4, 8, 4, 7, 4, 6, 4, 5, 4, 4, 5, 4, 4, 4, 4]],
  27: [[3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 4, 7, 0, 0, -1, 6, 7, 0, 0, -1, 7, 7, 0, 0, -1, 5, 7, 0, 0, -1, 8, 7, 0, 0, -1, 9, 7, 0, 0, -1, 10, 7, 0, 0, -1, 10, 6, 0, 0, -1, 10, 5, 0, 0, -1, 10, 4, 0, 0, -1, 10, 3, 0, 0, -1, 5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 7, 0, 0, 0, -1, 8, 0, 0, 0, -1, 9, 0, 0, 0, -1, 10, 0, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 8, 4, 2, 3, 0, 6, 5, 3, 0, 0, 5, 3, 3, 1, 0, 7, 2, 2, 0, 0, 4, 6, 0, 0, -1, 4, 3, 0, 0, -1, 5, 2, 0, 0, -1, 5, 1, 0, 0, -1, 4, 2, 0, 0, -1, 3, 2, 0, 0, -1], [8, 4, 8, 4, 6, 5, 5, 3, 8, 4, 6, 5, 8, 4, 6, 5, 8, 4, 6, 5, 8, 4, 7, 2, 7, 2, 5, 3, 6, 5, 8, 3, 8, 3, 5, 3, 8, 4, 6, 5, 8, 4, 8, 4, 8, 4, 8, 4, 9, 3, 9, 3, 9, 3, 9, 5, 9, 5, 9, 5, 9, 4, 9, 6, 9, 6, 9, 6, 9, 6]],
  28: [[6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 3, 7, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 7, 8, 0, 0, -1, 3, 3, 0, 0, -1, 4, 8, 0, 0, -1, 5, 8, 0, 0, -1, 6, 8, 0, 0, -1, 11, 3, 0, 0, -1, 11, 4, 0, 0, -1, 11, 5, 0, 0, -1, 11, 6, 0, 0, -1, 11, 7, 0, 0, -1, 10, 7, 0, 0, -1, 5, 5, 2, 3, 0, 7, 4, 2, 0, 0, 10, 4, 3, 3, 0, 9, 6, 4, 0, 0, 4, 3, 0, 0, -1, 5, 3, 0, 0, -1, 6, 3, 0, 0, -1, 4, 7, 0, 0, -1], [5, 5, 5, 5, 6, 5, 7, 4, 7, 4, 7, 5, 7, 7, 7, 7, 7, 7, 8, 7, 9, 6, 9, 6, 9, 6, 9, 7, 9, 5, 9, 6, 9, 6, 9, 6, 5, 6, 9, 6, 4, 6, 9, 5, 9, 5, 9, 6, 9, 5, 9, 6, 9, 4, 9, 5, 9, 4, 9, 4, 9, 5, 9, 4, 10, 4, 9, 5, 8, 4, 8, 4, 9, 4, 10, 4, 8, 4, 7, 4, 8, 4]],
  29: [[4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 8, 7, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 6, 4, 2, 0, 0, 4, 5, 3, 2, 0, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 9, 7, 0, 0, -1, 5, 5, 4, 0, 0, 6, 3, 3, 2, 0, 7, 6, 3, 0, 0, 7, 3, 0, 0, -1, 8, 3, 0, 0, -1, 4, 3, 0, 0, -1], [5, 5, 4, 5, 6, 5, 6, 4, 6, 4, 6, 5, 6, 5, 6, 4, 6, 4, 6, 5, 6, 5, 5, 5, 6, 5, 6, 5, 6, 4, 6, 5, 6, 5, 5, 5, 6, 3, 6, 5, 6, 5, 6, 6, 6, 6, 6, 5, 6, 5, 6, 6, 7, 6, 6, 5, 6, 5, 5, 6, 6, 6]],
  30: [[2, 2, 0, 0, -1, 2, 3, 0, 0, -1, 2, 4, 0, 0, -1, 2, 5, 0, 0, -1, 2, 6, 0, 0, -1, 2, 7, 0, 0, -1, 3, 7, 0, 0, -1, 4, 7, 0, 0, -1, 5, 7, 0, 0, -1, 6, 7, 0, 0, -1, 8, 7, 0, 0, -1, 9, 7, 0, 0, -1, 7, 7, 0, 0, -1, 9, 6, 0, 0, -1, 9, 5, 0, 0, -1, 9, 4, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 8, 2, 0, 0, -1, 7, 2, 0, 0, -1, 6, 2, 0, 0, -1, 4, 2, 0, 0, -1, 3, 2, 0, 0, -1, 4, 4, 2, 1, 0, 3, 3, 3, 2, 0, 7, 6, 2, 0, 0, 8, 4, 3, 3, 0, 4, 3, 0, 0, -1, 5, 3, 0, 0, -1, 6, 3, 0, 0, -1], [4, 4, 4, 4, 4, 4, 4, 4, 7, 6, 7, 6, 3, 3, 8, 4, 7, 6, 3, 5, 3, 5, 3, 5, 3, 5, 3, 3, 8, 4, 7, 6, 3, 6, 3, 6, 3, 6, 3, 6, 8, 6]],

  31: [[6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 10, 2, 0, 0, -1, 10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 7, 8, 0, 0, -1, 6, 8, 0, 0, -1, 11, 4, 0, 0, -1, 11, 5, 0, 0, -1, 11, 6, 0, 0, -1, 11, 7, 0, 0, -1, 4, 3, 0, 0, -1, 4, 7, 0, 0, -1, 5, 2, 0, 0, -1, 4, 4, 0, 0, -1, 4, 5, 0, 0, -1, 4, 6, 0, 0, -1, 4, 8, 0, 0, -1, 5, 8, 0, 0, -1, 11, 8, 0, 0, -1, 10, 5, 3, 3, 0, 9, 7, 2, 0, 0, 7, 5, 4, 0, 0, 6, 4, 2, 1, 0, 5, 7, 3, 1, 0, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 5, 3, 0, 0, -1], [9, 7, 9, 7, 10, 5, 9, 7, 10, 5, 6, 4, 6, 4, 6, 4, 9, 7, 9, 7, 6, 5, 6, 5, 6, 4, 6, 5, 6, 4, 6, 4, 6, 6, 6, 6, 6, 6, 6, 5, 6, 6, 6, 5, 6, 7, 6, 7, 6, 7, 6, 6, 6, 6, 6, 7, 6, 7, 6, 7, 5, 7, 7, 7, 7, 6, 7, 7, 7, 6, 7, 6, 6, 7, 8, 7, 9, 7, 9, 7, 7, 7, 7, 7, 7, 7, 8, 7, 7, 7, 8, 7]],
  32: [[3, 2, 0, 0, -1, 3, 3, 0, 0, -1, 3, 4, 0, 0, -1, 4, -2, 0, 0, -1, 5, -2, 0, 0, -1, 6, -2, 0, 0, -1, 7, -2, 0, 0, -1, 8, -2, 0, 0, -1, 9, -2, 0, 0, -1, 10, -2, 0, 0, -1, 6, 1, 3, 3, 0, 8, 2, 3, 0, 0, 6, 2, 4, 3, 0, 7, 2, 2, 2, 0, 10, -1, 0, 0, -1, 10, 0, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 9, 3, 0, 0, -1, 8, 3, 0, 0, -1, 8, 4, 0, 0, -1, 9, -1, 3, 3, 0, 9, 0, 3, 3, 0, 4, 2, 0, 0, -1, 4, 4, 0, 0, -1, 5, 4, 0, 0, -1, 6, 4, 0, 0, -1, 7, 4, 0, 0, -1, 4, 1, 0, 0, -1, 3, 1, 0, 0, -1, 3, 0, 0, 0, -1, 3, -1, 0, 0, -1, 3, -2, 0, 0, -1], [6, 2, 6, 2, 7, 2, 6, 1, 7, 2, 8, 2, 6, 1, 8, 2, 9, 0, 9, -1, 7, 2, 6, 1, 8, 2, 7, 2, 6, 1, 8, 2, 9, -1, 9, 0, 7, 2, 6, 1, 8, 2, 7, 2, 6, 1, 8, 2, 9, -1, 9, 0, 7, 2, 6, 1, 8, 2, 7, 2, 6, 1, 8, 2, 9, -1, 9, 0, 7, 2, 6, 1, 8, 2, 7, 2, 6, 1, 8, 2, 7, 2, 6, 1, 7, 2, 6, 1, 7, 2, 6, 2, 7, 2, 6, 2, 6, 2, 6, 2, 7, 2, 6, 2, 6, 1, 6, 3, 7, 3, 5, 3, 5, 3, 5, 3, 6, 3, 5, 3, 6, 3, 4, 3, 4, 3, 4, 3, 5, 3, 5, 3]],
  33: [[3, 0, 0, 0, -1, 4, 0, 0, 0, -1, 5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 7, 0, 0, 0, -1, 8, 0, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 2, 0, 0, -1, 3, 1, 0, 0, -1, 3, 3, 0, 0, -1, 6, 3, 2, 2, 0, 5, 2, 3, 3, 0, 7, 4, 2, 3, 0, 4, 5, 3, 0, 0, 6, 5, 2, 0, 0, 4, 6, 0, 0, -1, 5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 8, 6, 0, 0, -1, 8, 5, 0, 0, -1, 8, 4, 0, 0, -1, 8, 3, 0, 0, -1, 8, 2, 0, 0, -1, 8, 1, 0, 0, -1], [7, 4, 7, 4, 7, 4, 4, 5, 7, 4, 4, 5, 7, 4, 4, 5, 7, 4, 6, 5, 5, 2, 7, 2, 7, 2, 7, 2, 6, 5, 7, 5, 5, 5, 5, 5, 5, 5]],
  34: [[1, 1, 0, 0, -1, 2, 1, 0, 0, -1, 3, 1, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 3, 6, 0, 0, -1, 4, 6, 0, 0, -1, 2, 6, 0, 0, -1, 1, 5, 0, 0, -1, 1, 4, 0, 0, -1, 1, 3, 0, 0, -1, 1, 2, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 1, 6, 0, 0, -1, 9, 6, 0, 0, -1, 9, 5, 0, 0, -1, 9, 1, 0, 0, -1, 8, 1, 0, 0, -1, 7, 1, 0, 0, -1, 3, 0, 0, 0, -1, 4, 0, 0, 0, -1, 5, 0, 0, 0, -1, 7, 0, 0, 0, -1, 6, 0, 0, 0, -1, 5, 4, 2, 3, 0, 6, 5, 2, 0, 0, 8, 2, 3, 2, 0, 2, 3, 2, 1, 0], [5, 4, 5, 4, 5, 4, 5, 4, 6, 5, 6, 3, 6, 3, 6, 3, 6, 3, 7, 3, 8, 2, 2, 3, 8, 4, 8, 2, 2, 3, 6, 5, 6, 5, 8, 5, 8, 5, 5, 5, 5, 5, 8, 5, 4, 5, 4, 5, 8, 5, 3, 5, 8, 5, 2, 5, 2, 2]],
  35: [[10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 7, 8, 0, 0, -1, 6, 8, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 11, 4, 0, 0, -1, 11, 5, 0, 0, -1, 11, 6, 0, 0, -1, 11, 7, 0, 0, -1, 5, 8, 0, 0, -1, 4, 8, 0, 0, -1, 4, 7, 0, 0, -1, 4, 6, 0, 0, -1, 4, 5, 0, 0, -1, 4, 4, 0, 0, -1, 4, 3, 0, 0, -1, 7, 5, 2, 2, 0, 8, 6, 2, 0, 0, 6, 6, 3, 0, 0, 7, 6, 4, 2, 0, 6, 3, 0, 0, -1, 6, 2, 0, 0, -1, 5, 3, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 10, 4, 0, 0, -1, 10, 7, 0, 0, -1], [8, 6, 8, 6, 8, 6, 8, 6, 7, 6, 8, 6, 8, 6, 7, 5, 7, 5, 7, 6, 7, 5, 7, 5, 7, 5, 7, 6, 7, 5, 7, 5, 7, 6, 8, 6, 7, 6, 7, 6, 7, 5, 7, 7, 8, 7, 8, 7, 7, 7, 7, 6, 5, 6, 6, 6, 5, 7, 6, 7]],
  36: [[5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 10, 1, 0, 0, -1, 11, 1, 0, 0, -1, 10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 7, 8, 0, 0, -1, 6, 8, 0, 0, -1, 5, 7, 0, 0, -1, 5, 6, 0, 0, -1, 5, 5, 0, 0, -1, 5, 4, 0, 0, -1, 5, 3, 0, 0, -1, 5, 2, 0, 0, -1, 8, 5, 2, 1, 0, 7, 5, 2, 0, 0, 6, 4, 0, 0, -1, 6, 5, 0, 0, -1, 7, 4, 4, 0, 0, 6, 3, 3, 1, 0, 9, 2, 3, 3, 0, 10, 6, 3, 0, 0, 10, 7, 0, 0, -1, 11, 7, 0, 0, -1, 11, 6, 0, 0, -1, 11, 5, 0, 0, -1, 11, 4, 0, 0, -1, 11, 3, 0, 0, -1, 11, 2, 0, 0, -1, 6, 7, 0, 0, -1], [7, 4, 7, 4, 7, 5, 7, 5, 7, 5, 6, 3, 7, 4, 8, 3, 7, 3, 9, 3, 8, 3, 9, 3, 9, 3, 9, 3, 9, 2, 9, 3, 8, 3, 9, 3, 9, 3, 9, 3, 9, 2, 9, 3, 8, 3, 8, 3, 9, 2, 9, 4, 9, 4, 9, 3, 9, 5, 8, 5, 8, 5, 9, 5, 8, 5, 10, 5, 10, 5, 10, 5, 9, 5, 10, 6, 9, 5, 9, 5, 10, 5, 10, 6, 9, 5, 10, 4, 10, 4, 10, 4, 10, 5, 10, 3, 10, 4, 10, 3, 10, 3, 10, 3, 9, 3, 10, 4, 10, 2, 10, 3]],
  37: [[3, 5, 0, 0, -1, 10, 5, 0, 0, -1, 9, 6, 0, 0, -1, 8, 7, 0, 0, -1, 4, 7, 0, 0, -1, 4, 6, 0, 0, -1, 4, 0, 0, 0, -1, 5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 7, 0, 0, 0, -1, 8, 0, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 10, 1, 0, 0, -1, 4, 1, 0, 0, -1, 3, 1, 0, 0, -1, 10, 2, 0, 0, -1, 3, 2, 0, 0, -1, 7, 3, 2, 0, 0, 6, 3, 4, 0, 0, 6, 4, 2, 1, 0, 10, 3, 0, 0, -1, 4, 5, 0, 0, -1, 8, 5, 2, 0, 0, 9, 5, 0, 0, -1, 8, 6, 0, 0, -1, 10, 4, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 3, 3, 0, 0, -1, 3, 4, 0, 0, -1], [6, 4, 6, 3, 6, 3, 6, 4, 6, 4, 6, 4, 7, 4, 8, 5, 7, 3, 7, 3, 6, 3, 6, 3, 7, 3, 7, 3, 8, 3, 6, 3, 6, 3, 5, 3, 5, 3, 6, 3, 6, 3, 8, 3, 5, 3, 5, 3, 4, 3, 4, 3, 5, 3, 5, 3, 8, 5, 8, 2, 8, 2, 4, 3, 5, 3]],
  38: [[2, 2, 0, 0, -1, 2, 6, 0, 0, -1, 2, 5, 0, 0, -1, 2, 4, 0, 0, -1, 2, 3, 0, 0, -1, 2, 1, 0, 0, -1, 3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 4, 3, 2, 1, 0, 5, 4, 4, 0, 0, 7, 5, 4, 0, 0, 7, 2, 2, 0, 0, 9, 2, 0, 0, -1, 9, 6, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 4, 6, 0, 0, -1, 3, 6, 0, 0, -1], [7, 2, 7, 3, 7, 5, 7, 4, 7, 4, 7, 4, 5, 4, 5, 4, 5, 4, 6, 4, 6, 4, 5, 4, 6, 4, 4, 4, 4, 4, 4, 4, 5, 4, 5, 4, 4, 3, 4, 4, 5, 4, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 3, 3, 3, 3, 4, 4, 3, 5, 3, 5, 3, 5, 4, 5, 5, 5, 6, 5, 7, 5, 9, 5, 8, 5]],
  39: [[5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 7, 0, 0, 0, -1, 8, 0, 0, 0, -1, 9, 0, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 3, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 3, 2, 0, 0, -1, 7, 4, 4, 0, 0, 8, 5, 3, 3, 0, 6, 3, 2, 3, 0, 9, 6, 0, 0, -1, 5, 1, 0, 0, -1, 5, 2, 0, 0, -1, 4, 2, 0, 0, -1, 9, 2, 0, 0, -1, 9, 1, 0, 0, -1, 5, 6, 0, 0, -1, 4, 6, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1], [6, 3, 6, 3, 6, 3, 7, 4, 7, 3, 7, 3, 7, 4, 7, 3, 7, 3, 7, 4, 7, 4, 7, 4, 7, 3, 7, 5, 7, 4, 8, 5, 7, 4, 8, 5, 7, 4, 7, 4, 7, 4, 7, 5, 7, 5, 7, 5, 8, 5, 6, 5, 6, 5, 6, 4, 6, 4, 6, 5, 6, 4, 6, 4, 6, 4, 6, 6, 6, 5, 6, 5, 6, 5, 5, 5]],

  40: [[3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 8, 6, 0, 0, -1, 7, 6, 0, 0, -1, 7, 5, 0, 0, -1, 6, 5, 0, 0, -1, 6, 6, 0, 0, -1, 5, 6, 0, 0, -1, 4, 6, 0, 0, -1, 4, 5, 0, 0, -1, 4, 4, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 3, 2, 0, 0, -1, 4, 3, 3, 2, 0, 5, 3, 4, 0, 0, 6, 4, 2, 1, 0, 7, 4, 3, 1, 0], [5, 3, 5, 3, 6, 4, 6, 4, 5, 3, 4, 3, 5, 4, 5, 4, 6, 3, 5, 3, 6, 3, 8, 3, 8, 3, 8, 3, 8, 4, 7, 3, 8, 2, 7, 2, 7, 2, 7, 2, 7, 2, 9, 2, 9, 2, 9, 2, 8, 2, 8, 2]],
  41: [[2, 2, 0, 0, -1, 3, 2, 0, 0, -1, 4, 2, 0, 0, -1, 5, 2, 0, 0, -1, 6, 2, 0, 0, -1, 7, 2, 0, 0, -1, 8, 2, 0, 0, -1, 9, 2, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 9, 7, 0, 0, -1, 8, 7, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 2, 7, 0, 0, -1, 2, 6, 0, 0, -1, 2, 5, 0, 0, -1, 2, 4, 0, 0, -1, 2, 3, 0, 0, -1, 7, 4, 2, 0, 0, 5, 5, 3, 0, 0, 6, 5, 4, 0, 0, 8, 4, 3, 3, 0], [7, 4, 7, 4, 8, 4, 7, 5, 8, 4, 7, 5, 8, 4, 7, 5, 8, 4, 6, 5, 5, 5, 7, 5, 7, 5, 7, 5, 8, 5, 7, 5, 8, 5, 6, 5, 6, 5, 6, 5, 7, 5, 8, 3, 7, 5, 8, 3, 7, 5, 8, 3, 7, 5, 8, 3, 7, 5, 6, 5, 7, 5, 6, 5, 4, 5, 4, 5, 4, 5, 3, 5, 4, 5, 5, 5, 3, 5, 4, 5, 3, 6, 4, 5, 3, 6, 4, 5, 3, 6, 4, 5, 3, 6, 4, 5]],
  42: [[2, 2, 0, 0, -1, 2, 7, 0, 0, -1, 2, 6, 0, 0, -1, 2, 5, 0, 0, -1, 2, 4, 0, 0, -1, 2, 3, 0, 0, -1, 2, 1, 0, 0, -1, 3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 1, 0, 0, -1, 10, 1, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 10, 7, 0, 0, -1, 10, 8, 0, 0, -1, 9, 8, 0, 0, -1, 7, 8, 0, 0, -1, 8, 8, 0, 0, -1, 6, 8, 0, 0, -1, 5, 8, 0, 0, -1, 4, 8, 0, 0, -1, 3, 8, 0, 0, -1, 2, 8, 0, 0, -1, 4, 4, 2, 0, 0, 6, 5, 2, 3, 0, 5, 4, 4, 3, -1, 9, 6, 3, 3, 0], [5, 4, 5, 4, 5, 4, 4, 4, 4, 4, 6, 5, 6, 5, 6, 5, 6, 5, 5, 4, 7, 5, 6, 4, 8, 4, 8, 4, 8, 4, 8, 5, 9, 6, 8, 5, 9, 6, 8, 5, 9, 6, 8, 5, 9, 6, 8, 5, 9, 6, 8, 5, 8, 4, 8, 5, 7, 4, 9, 4, 9, 4, 9, 4, 9, 5, 8, 4, 9, 7, 8, 4, 9, 7, 8, 4, 9, 7, 8, 4, 9, 7, 8, 4, 9, 7, 8, 4, 9, 5, 8, 4, 9, 3, 8, 3, 8, 3, 8, 3, 8, 3, 8, 3, 9, 3, 9, 3, 9, 3, 9, 4, 8, 3, 9, 2, 8, 2, 8, 2, 8, 2, 8, 2, 8, 2]],
  43: [[5, 0, 0, 0, -1, 6, 0, 0, 0, -1, 7, 0, 0, 0, -1, 8, 0, 0, 0, -1, 9, 0, 0, 0, -1, 10, 2, 0, 0, -1, 10, 3, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 10, 6, 0, 0, -1, 3, 5, 0, 0, -1, 3, 4, 0, 0, -1, 3, 3, 0, 0, -1, 3, 2, 0, 0, -1, 4, 0, 0, 0, -1, 3, 0, 0, 0, -1, 3, 1, 0, 0, -1, 10, 0, 0, 0, -1, 10, 1, 0, 0, -1, 10, 7, 0, 0, -1, 9, 7, 0, 0, -1, 8, 7, 0, 0, -1, 7, 7, 0, 0, -1, 6, 7, 0, 0, -1, 5, 7, 0, 0, -1, 4, 7, 0, 0, -1, 3, 7, 0, 0, -1, 3, 6, 0, 0, -1, 5, 3, 2, 0, 0, 7, 2, 2, 2, 0, 7, 3, 4, 0, 0, 8, 4, 3, 3, 0], [7, 3, 7, 3, 7, 2, 7, 2, 8, 4, 7, 3, 8, 4, 5, 3, 5, 3, 5, 3, 6, 4, 6, 4, 6, 4, 6, 4, 5, 5, 5, 4, 5, 5, 5, 5, 5, 5, 8, 4, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 4, 5, 5, 5, 6, 5, 8, 5, 8, 5, 8, 5, 9, 5, 9, 5, 9, 5, 9, 5, 9, 5, 8, 4, 8, 6, 9, 6, 7, 6, 7, 6, 7, 6, 8, 6, 8, 6, 8, 6, 8, 6, 7, 6, 8, 6, 7, 6, 6, 6, 7, 5]],
  44: [[3, 1, 0, 0, -1, 4, 1, 0, 0, -1, 5, 1, 0, 0, -1, 6, 1, 0, 0, -1, 7, 1, 0, 0, -1, 8, 1, 0, 0, -1, 9, 8, 0, 0, -1, 8, 8, 0, 0, -1, 7, 8, 0, 0, -1, 6, 8, 0, 0, -1, 5, 8, 0, 0, -1, 4, 8, 0, 0, -1, 3, 8, 0, 0, -1, 7, 3, 3, 3, 0, 5, 3, 3, 2, 0, 6, 5, 2, 0, 0, 5, 6, 2, 2, 0, 4, 4, 2, 1, 0, 8, 4, 3, 3, 0, 3, 3, 0, 0, -1, 3, 2, 0, 0, -1, 8, 2, 0, 0, -1, 8, 3, 0, 0, -1, 9, 3, 0, 0, -1, 9, 4, 0, 0, -1, 9, 5, 0, 0, -1, 9, 6, 0, 0, -1, 9, 7, 0, 0, -1, 3, 5, 0, 0, -1, 3, 6, 0, 0, -1, 3, 7, 0, 0, -1, 3, 4, 0, 0, -1], [5, 6, 5, 6, 5, 5, 4, 4, 4, 4, 6, 5, 7, 3, 6, 5, 6, 5, 7, 4, 7, 4, 7, 4, 7, 4, 7, 2, 6, 5, 7, 2, 6, 5, 4, 3, 8, 4, 7, 3, 6, 5, 4, 5, 4, 3, 8, 4, 7, 3, 6, 6, 4, 6, 4, 3, 8, 4, 7, 3, 4, 7]],
  45: [[5, 6, 0, 0, -1, 6, 6, 0, 0, -1, 7, 6, 0, 0, -1, 8, 6, 0, 0, -1, 8, 0, 0, 0, -1, 7, 0, 0, 0, -1, 6, 0, 0, 0, -1, 5, 0, 0, 0, -1, 6, 2, 2, 2, 0, 7, 5, 3, 3, 0, 7, 4, 4, 1, 0, 7, 1, 3, 3, 0, 9, 0, 0, 0, -1, 9, 6, 0, 0, -1, 10, 3, 0, 0, -1, 10, 2, 0, 0, -1, 10, 1, 0, 0, -1, 10, 4, 0, 0, -1, 10, 5, 0, 0, -1, 4, 5, 0, 0, -1, 4, 3, 0, 0, -1, 4, 2, 0, 0, -1, 4, 1, 0, 0, -1, 4, 4, 0, 0, -1, 9, 2, 3, 3, 0, 9, 1, 0, 0, -1, 9, 5, 0, 0, -1, 5, 1, 0, 0, -1, 5, 5, 0, 0, -1], [7, 4, 7, 4, 7, 4, 7, 5, 7, 3, 7, 3, 7, 4, 6, 2, 6, 2, 6, 2, 7, 2, 6, 2, 7, 2, 6, 2, 7, 2, 7, 2, 7, 1, 7, 2, 6, 2, 8, 2, 9, 2, 8, 1, 7, 2, 7, 2, 8, 3, 8, 3, 7, 3, 8, 3, 7, 3, 8, 2, 8, 3, 9, 3, 8, 3, 8, 3, 8, 3, 7, 3, 9, 3, 8, 3, 8, 3, 9, 3, 9, 3, 8, 3, 9, 4, 8, 3, 8, 3]],
};